import React, { useState } from 'react';

// NOTA: As funções virão do App.js
const CriarContaView = ({ onRegister, onNavigateToLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('As palavras-passe não coincidem.');
            return;
        }
        setError('');
        setIsLoading(true);
        try {
            await onRegister(email, password);
            // Se o registo for bem-sucedido, o App.js irá redirecionar
        } catch (err) {
            // --- LÓGICA DE ERRO ATUALIZADA ---
            if (err.code === 'auth/email-already-in-use') {
                setError('Este email já está a ser utilizado.');
            } else if (err.code === 'auth/email-blocked') {
                // Apanha o nosso novo erro personalizado vindo do App.js
                setError('Este endereço de e-mail não é permitido. Por favor, entre em contato com o suporte.');
            } else {
                // Mensagem genérica para outros erros
                setError('Ocorreu um erro ao criar a conta. Tente novamente.');
            }
            console.error("Falha no registo:", err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-2xl shadow-lg">
                <h2 className="text-3xl font-bold text-center text-gray-800">
                    Crie a Sua Conta
                </h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="register-email" className="form-label sr-only">Email</label>
                        <input
                            id="register-email"
                            name="email"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D7BFBD]"
                            placeholder="Email"
                        />
                    </div>
                    <div>
                        <label htmlFor="register-password" aria-label="Palavra-passe" className="form-label sr-only">Palavra-passe</label>
                        <input
                            id="register-password"
                            name="password"
                            type="password"
                            required
                            minLength="6"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D7BFBD]"
                            placeholder="Palavra-passe (mín. 6 caracteres)"
                        />
                    </div>
                    <div>
                        <label htmlFor="confirm-password" aria-label="Confirmar palavra-passe" className="form-label sr-only">Confirmar palavra-passe</label>
                        <input
                            id="confirm-password"
                            name="confirmPassword"
                            type="password"
                            required
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D7BFBD]"
                            placeholder="Confirme a sua palavra-passe"
                        />
                    </div>

                    {error && <p className="text-sm text-center text-red-600">{error}</p>}

                    <div>
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full custom-button py-3 font-semibold rounded-lg shadow-sm disabled:opacity-50"
                        >
                            {isLoading ? 'A criar...' : 'Criar Conta'}
                        </button>
                    </div>
                </form>
                <p className="text-sm text-center text-gray-600">
                    Já tem uma conta?{' '}
                    <button onClick={onNavigateToLogin} className="font-semibold text-[#BF9A91] hover:underline">
                        Entre aqui
                    </button>
                </p>
            </div>
        </div>
    );
};

export default CriarContaView;